import addMount from "../../core/addMount";
import RecommendedMaterial from "./RecommendedMaterial";

addMount({ appName: "recommended-material", app: RecommendedMaterial });
